import { c as _c } from "react/compiler-runtime";
import { useCallback, type MouseEvent } from 'react';
import classnames from 'classnames';
import { batch, connect } from 'react-redux';
import { Category, getAllCategories, getCategoryByID } from '@sbt-web/category-utils';
import { useViewport } from '@sbt-web/hooks';
import { CategoryID, FilterURI, GeoEntry } from '@sbt-web/network/types';
import { SearchAutocomplete, type RecentSearchOption, type SearchAutocompleteOption } from '@sbt-web/search-autocomplete';
import type { RootState } from '@/reducers/index';
import { updateCategory, updateFilter, updateGeo, updateQuery, updateRecentSearch } from '@/reducers/search';
import { setPreventPopstate } from '@/reducers/system';
import { CategorySelector } from '../Filters/CategorySelector';
import { QueryGeoInput } from '../Filters/QueryGeoInput';
import NationwideSearchExpander from '../SearchNationwide';
import '@sbt-web/search-autocomplete/dist/index.css';
import ownClasses from './search-bar.module.scss';
interface CategoryInfo {
  key: CategoryID;
  label: string;
}
interface OwnProps {
  onFiltersOpen: () => void;
}
interface DispatchProps {
  updateSearch: (query?: string, category?: Category, clothingType?: string, geo?: GeoEntry) => void;
  setPreventPopstate: (open: boolean) => void;
  updateRecentSearch: (state: RecentSearchOption) => void;
}
interface StateProps {
  query: string;
  category: Category;
}
export type Props = OwnProps & StateProps & DispatchProps;
export interface State {
  categoryId: CategoryID;
  categoryIndex: number;
}
const categoryList = getAllCategories();
function getCategoryIndex(categoryId: CategoryID): number {
  return categoryList.findIndex(c => c.id === categoryId);
}
export function SearchBar(t0) {
  const $ = _c(50);
  const {
    category,
    onFiltersOpen,
    query: t1,
    updateSearch,
    setPreventPopstate,
    updateRecentSearch
  } = t0;
  const query = t1 === undefined ? "" : t1;
  const {
    isMobile
  } = useViewport();
  let t2;
  if ($[0] !== category.id) {
    t2 = getCategoryIndex(category.id);
    $[0] = category.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const categoryIndex = t2;
  let t3;
  if ($[2] !== updateSearch) {
    t3 = options => {
      const categoryId = options.key;
      const newCategory = getCategoryByID(categoryId);
      updateSearch(undefined, newCategory);
    };
    $[2] = updateSearch;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onCategoryChange = t3;
  let t4;
  if ($[4] !== category || $[5] !== updateSearch) {
    t4 = () => updateSearch("", category);
    $[4] = category;
    $[5] = updateSearch;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const clearQuery = t4;
  let t5;
  if ($[7] !== onFiltersOpen) {
    t5 = e => {
      e.preventDefault();
      onFiltersOpen();
    };
    $[7] = onFiltersOpen;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const showFiltersDialog = t5;
  let t6;
  if ($[9] !== clearQuery || $[10] !== updateSearch) {
    t6 = item => {
      if (!item) {
        clearQuery();
        return;
      }
      const query_0 = item.filters?.find(_temp);
      const autocompleteCategory = item.filters?.find(_temp2);
      let newQueryValue = undefined;
      if (query_0?.values?.[0]?.label || query_0?.values?.[0]?.label === "") {
        newQueryValue = query_0.values[0].label;
      }
      let newCategory_0 = undefined;
      if (autocompleteCategory?.values?.[0]?.key) {
        newCategory_0 = getCategoryByID(autocompleteCategory.values[0].key as CategoryID);
      }
      const newClothingType = item.filters?.find(_temp3)?.values?.[0]?.key;
      updateSearch(newQueryValue, newCategory_0, newClothingType, item.geo);
    };
    $[9] = clearQuery;
    $[10] = updateSearch;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const onAutocompleteSelect = t6;
  let t7;
  if ($[12] !== updateRecentSearch) {
    t7 = item_0 => {
      updateRecentSearch(item_0);
    };
    $[12] = updateRecentSearch;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const onRecentSearchSelect = t7;
  let t8;
  if ($[14] !== setPreventPopstate) {
    t8 = () => {
      setPreventPopstate(true);
    };
    $[14] = setPreventPopstate;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const signalDialogOpening = t8;
  let t9;
  if ($[16] !== setPreventPopstate) {
    t9 = () => {
      setPreventPopstate(false);
    };
    $[16] = setPreventPopstate;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const signalDialogClosing = t9;
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = classnames(ownClasses["searchbar-container"]);
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = classnames(ownClasses["input-container"]);
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <label htmlFor="/query/search_text" className={classnames("caption", ownClasses.label)}>Cosa cerchi?</label>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== onAutocompleteSelect || $[22] !== onRecentSearchSelect || $[23] !== query || $[24] !== signalDialogClosing || $[25] !== signalDialogOpening) {
    t13 = <div id="search-query-container" className={t11}>{t12}<SearchAutocomplete assetsBase={process.env.NEXT_PUBLIC_ASSETS_BASE_URL} hadesBasePath={process.env.NEXT_PUBLIC_HADES_BASE_URL} initialValue={query} onSelect={onAutocompleteSelect} onDialogOpen={signalDialogOpening} onDialogClose={signalDialogClosing} onRecentSearchSelect={onRecentSearchSelect} /></div>;
    $[21] = onAutocompleteSelect;
    $[22] = onRecentSearchSelect;
    $[23] = query;
    $[24] = signalDialogClosing;
    $[25] = signalDialogOpening;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = classnames(ownClasses["category-container"], ownClasses["input-container"]);
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== isMobile) {
    t15 = !isMobile ? <p className={classnames("caption", ownClasses.label)}>In quale categoria?</p> : null;
    $[28] = isMobile;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== categoryIndex || $[31] !== onCategoryChange || $[32] !== showFiltersDialog) {
    t16 = <CategorySelector categoryList={categoryList} categoryIndex={categoryIndex} onCategoryChange={onCategoryChange} onFiltersButtonClick={showFiltersDialog} />;
    $[30] = categoryIndex;
    $[31] = onCategoryChange;
    $[32] = showFiltersDialog;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t15 || $[35] !== t16) {
    t17 = <div id="search-category-container" className={t14}>{t15}{t16}</div>;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = classnames(ownClasses["input-container"]);
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== isMobile) {
    t19 = !isMobile ? <label htmlFor="/geo" className={classnames("caption", ownClasses.label)}>Dove?</label> : null;
    $[38] = isMobile;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <QueryGeoInput />;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== isMobile) {
    t21 = isMobile ? <NationwideSearchExpander id="listing-mobile-nationwide-search-expander" /> : null;
    $[41] = isMobile;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t19 || $[44] !== t21) {
    t22 = <div id="search-location-container" className={t18}>{t19}{t20}{t21}</div>;
    $[43] = t19;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t13 || $[47] !== t17 || $[48] !== t22) {
    t23 = <div className={t10}>{t13}{t17}{t22}</div>;
    $[46] = t13;
    $[47] = t17;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  return t23;
}
function _temp3(f_1) {
  return f_1.uri === FilterURI.MarketClothingType;
}
function _temp2(f_0) {
  return f_0.uri === FilterURI.Category;
}
function _temp(f) {
  return f.uri === FilterURI.Query;
}
SearchBar.displayName = 'SearchBar';
export default connect<StateProps, DispatchProps, unknown, RootState>(state => ({
  query: state.search.query as string,
  category: state.search.category
}), dispatch => ({
  updateSearch: (query?: string, category?: Category, clothingType?: string, geo?: GeoEntry) => {
    batch(() => {
      if (category != null) {
        dispatch(updateCategory(category));
      }
      if (query || query === '') {
        dispatch(updateQuery(query));
      }
      dispatch(updateFilter({
        key: 'clt',
        value: clothingType ?? '',
        uri: FilterURI.MarketClothingType
      }));
      if (geo) {
        dispatch(updateGeo(geo));
      }
    });
  },
  setPreventPopstate: (isOpen: boolean) => dispatch(setPreventPopstate(isOpen)),
  updateRecentSearch: (search?: RecentSearchOption) => {
    dispatch(updateRecentSearch(search as RecentSearchOption));
  }
}))(SearchBar);